import { render, staticRenderFns } from "./Audio_3.vue?vue&type=template&id=4c3ec6b0&scoped=true"
import script from "./Audio_3.vue?vue&type=script&lang=js"
export * from "./Audio_3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ec6b0",
  null
  
)

export default component.exports